import {
  List,
  TextField,
  EditButton,
  ShowButton,
  SimpleList,
  Datagrid,
  ReferenceField,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT, POSITIONS } from "utils/constants";
import { AdministrationExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { employeeRequests } from "api/employeeApi";
import { MobileListRow } from "features/MobileListRow";

const ListPositions = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={AdministrationExporter(POSITIONS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Позиции"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateEmployeePositions)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.nameBg }]} />}
          secondaryText={() => (
            <MobileListRow
              fields={[
                {
                  label: "Тип позиция",
                  value: (
                    <ReferenceField
                      label="Тип позиция"
                      source="typeId"
                      reference={employeeRequests.getPositionTypesSelect()}
                    >
                      <TextField
                        label="Тип позиция"
                        source="name"
                      />
                    </ReferenceField>
                  ),
                },
              ]}
            />
          )}
          tertiaryText={record => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateEmployeePositions) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="nameBg"
            label="Име"
            sortable={false}
          />
          <ReferenceField
            label="Тип позиция"
            source="typeId"
            reference={employeeRequests.getPositionTypesSelect()}
          >
            <TextField
              label="Тип позиция"
              source="name"
            />
          </ReferenceField>
          {checkPermission(userPermissions, permissions.canUpdateEmployeePositions) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListPositions;
